module.exports = __webpack_public_path__ + "img/icon_inst.396dbf02.svg";